module.exports = "/static/media/arrow.d3186e59.svg";